import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "px-[34px] pt-14 pb-[120px] w-full max-w-[600px] mx-auto" }
const _hoisted_2 = { class: "mb-6" }
const _hoisted_3 = { class: "font-sourcesanspro-semibold text-xs2 text-white/60 leading-none" }
const _hoisted_4 = { class: "font-sourcesanspro-semibold text-m2 text-white leading-tight" }
const _hoisted_5 = {
  key: 0,
  class: "rounded backdrop-blur-xl bg-white/10 text-white p-4"
}
const _hoisted_6 = { class: "font-sourcesanspro-semibold text-base2" }
const _hoisted_7 = {
  key: 0,
  class: "mb-4 space-y-2"
}
const _hoisted_8 = { class: "flex-1" }
const _hoisted_9 = { class: "font-sourcesanspro-semibold text-base2" }
const _hoisted_10 = { class: "text-sm2 opacity-90" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "font-sourcesanspro-semibold text-l2 uppercase" }
const _hoisted_13 = { class: "text-center text-white/60 text-xs2 font-sourcesanspro-regular mt-2" }
const _hoisted_14 = { class: "text-white font-sourcesanspro-semibold text-l2 mt-8 mb-3" }
const _hoisted_15 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "w-9 h-9 rounded-full bg-white/10 flex items-center justify-center" }
const _hoisted_18 = { class: "font-sourcesanspro-semibold text-sm2 text-center leading-tight" }
const _hoisted_19 = { class: "flex-1 text-left" }
const _hoisted_20 = { class: "font-sourcesanspro-semibold text-l2 leading-tight" }
const _hoisted_21 = { class: "text-white/60 text-xs2 font-sourcesanspro-regular" }
const _hoisted_22 = { class: "text-white font-sourcesanspro-semibold text-l2 mt-8 mb-3" }
const _hoisted_23 = { class: "space-y-2" }
const _hoisted_24 = { class: "font-sourcesanspro-semibold text-base2 mb-1" }
const _hoisted_25 = { class: "font-sourcesanspro-regular text-sm2 text-white/80" }
const _hoisted_26 = { class: "text-white font-sourcesanspro-semibold text-l2 mt-8 mb-3" }
const _hoisted_27 = { class: "space-y-2" }
const _hoisted_28 = ["href"]
const _hoisted_29 = { class: "flex-1" }
const _hoisted_30 = { class: "font-sourcesanspro-semibold text-base2" }
const _hoisted_31 = { class: "text-white/60 text-sm2 font-sourcesanspro-regular" }

import { computed } from 'vue';
import { IonContent, IonFooter, IonIcon, IonRefresher, IonRefresherContent, RefresherCustomEvent } from '@ionic/vue';
import { alertCircle, bagRemoveOutline, bodyOutline, call, carSportOutline, documentText, eyeOutline, flameOutline, helpCircleOutline, medkitOutline, searchCircleOutline, shieldCheckmarkOutline, warning } from 'ionicons/icons';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

import NavigationBar from '@/shared/components/ui/NavigationBar.vue';
import useSafety, { IncidentType } from '@/modules/safety/composables/useSafety';


export default /*@__PURE__*/_defineComponent({
  __name: 'SafetyPage',
  setup(__props) {

const { t } = useI18n();
const router = useRouter();

const { getSafetyConfig, getMyReports, getActiveBroadcasts, ackBroadcast } = useSafety();
const { config, refetchConfig } = getSafetyConfig();
const { reports, refetchReports } = getMyReports();
const { broadcasts, refetchBroadcasts } = getActiveBroadcasts();

const openReportsCount = computed(() => reports.value.filter((r) => ['open', 'assigned', 'in_progress'].includes(r.status)).length);

const goToReport = (type: IncidentType) => {
	router.push({ name: 'safety-report', params: { type } });
};

const goToSos = () => {
	router.push({ name: 'safety-sos' });
};

const goToMyReports = () => {
	router.push({ name: 'safety-my-reports' });
};

const dismissBroadcast = async (id: number) => {
	await ackBroadcast(id);
};

const onRefresh = async (ev: RefresherCustomEvent) => {
	await Promise.all([refetchConfig(), refetchReports(), refetchBroadcasts()]);
	ev.target.complete();
};

const iconFor = (type: IncidentType) => {
	switch (type) {
		case 'medical':
			return medkitOutline;
		case 'fire':
			return flameOutline;
		case 'security':
			return shieldCheckmarkOutline;
		case 'aggression':
			return bodyOutline;
		case 'lost_person':
			return searchCircleOutline;
		case 'theft':
			return bagRemoveOutline;
		case 'suspicious':
			return eyeOutline;
		case 'accident':
			return carSportOutline;
		default:
			return helpCircleOutline;
	}
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonContent), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonRefresher), {
          class: "mt-8",
          slot: "fixed",
          onIonRefresh: onRefresh
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonRefresherContent))
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('navigation.safety')), 1),
            _createElementVNode("h1", _hoisted_4, _toDisplayString(_unref(t)('safety.title')), 1)
          ]),
          (_unref(config)?.enabled === false)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('safety.disabled')), 1)
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_unref(broadcasts).length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(broadcasts), (b) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: b.id,
                          class: _normalizeClass(["rounded p-4 flex items-start gap-3 font-sourcesanspro-regular", {
							'bg-red-600 text-white': b.priority === 'critical',
							'bg-yellow-500 text-black': b.priority === 'warning',
							'bg-blue-600 text-white': b.priority === 'info',
						}])
                        }, [
                          _createVNode(_unref(IonIcon), {
                            icon: _unref(warning),
                            class: "text-l2 shrink-0 mt-0.5"
                          }, null, 8, ["icon"]),
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, _toDisplayString(b.title), 1),
                            _createElementVNode("div", _hoisted_10, _toDisplayString(b.body), 1)
                          ]),
                          _createElementVNode("button", {
                            class: "text-sm2 underline opacity-80",
                            onClick: ($event: any) => (dismissBroadcast(b.id))
                          }, _toDisplayString(_unref(t)('general.dismiss')), 9, _hoisted_11)
                        ], 2))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "w-full h-[80px] rounded bg-red-600 text-white px-4 flex items-center justify-center gap-3 active:scale-[0.98] transition-transform",
                  onClick: goToSos
                }, [
                  _createVNode(_unref(IonIcon), {
                    icon: _unref(alertCircle),
                    class: "text-l2"
                  }, null, 8, ["icon"]),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)('safety.sos')), 1)
                ]),
                _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(t)('safety.sos_description')), 1),
                _createElementVNode("h2", _hoisted_14, _toDisplayString(_unref(t)('safety.report_something')), 1),
                _createElementVNode("div", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(config)?.incident_types ?? [], (type) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: type,
                      class: "h-[92px] rounded backdrop-blur-xl bg-white/10 text-white px-3 flex flex-col items-center justify-center gap-2 active:bg-white/20",
                      onClick: ($event: any) => (goToReport(type))
                    }, [
                      _createElementVNode("span", _hoisted_17, [
                        _createVNode(_unref(IonIcon), {
                          icon: iconFor(type),
                          class: "text-[22px]"
                        }, null, 8, ["icon"])
                      ]),
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(t)(`safety.types.${type}`)), 1)
                    ], 8, _hoisted_16))
                  }), 128))
                ]),
                _createElementVNode("button", {
                  class: "mt-8 w-full h-[80px] rounded backdrop-blur-xl bg-white/10 text-white px-4 flex items-center gap-3 active:bg-white/20",
                  onClick: goToMyReports
                }, [
                  _createVNode(_unref(IonIcon), {
                    icon: _unref(documentText),
                    class: "text-l2 shrink-0"
                  }, null, 8, ["icon"]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(t)('safety.my_reports')), 1),
                    _createElementVNode("div", _hoisted_21, _toDisplayString(openReportsCount.value ? _unref(t)('safety.open_count', { count: openReportsCount.value }) : _unref(t)('safety.no_open_reports')), 1)
                  ])
                ]),
                ((_unref(config)?.info_cards?.length ?? 0) > 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("h2", _hoisted_22, _toDisplayString(_unref(t)('safety.good_to_know')), 1),
                      _createElementVNode("div", _hoisted_23, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(config)?.info_cards ?? [], (card, idx) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: idx,
                            class: "rounded backdrop-blur-xl bg-white/10 text-white p-4"
                          }, [
                            _createElementVNode("div", _hoisted_24, _toDisplayString(card.title), 1),
                            _createElementVNode("div", _hoisted_25, _toDisplayString(card.body), 1)
                          ]))
                        }), 128))
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                ((_unref(config)?.emergency_contacts?.length ?? 0) > 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createElementVNode("h2", _hoisted_26, _toDisplayString(_unref(t)('safety.emergency_contacts')), 1),
                      _createElementVNode("div", _hoisted_27, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(config)?.emergency_contacts ?? [], (contact, idx) => {
                          return (_openBlock(), _createElementBlock("a", {
                            key: idx,
                            href: `tel:${contact.value}`,
                            class: "rounded backdrop-blur-xl bg-white/10 text-white p-4 flex items-center gap-3 active:bg-white/20"
                          }, [
                            _createVNode(_unref(IonIcon), {
                              icon: _unref(call),
                              class: "text-l2"
                            }, null, 8, ["icon"]),
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("div", _hoisted_30, _toDisplayString(contact.label), 1),
                              _createElementVNode("div", _hoisted_31, _toDisplayString(contact.value), 1)
                            ])
                          ], 8, _hoisted_28))
                        }), 128))
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ], 64))
        ])
      ]),
      _: 1
    }),
    _createVNode(_unref(IonFooter), null, {
      default: _withCtx(() => [
        _createVNode(NavigationBar, { "item-active": "safety" })
      ]),
      _: 1
    })
  ], 64))
}
}

})